// extracted by mini-css-extract-plugin
export default {"container":"Buttons_container__h2fVW","continuar":"Buttons_continuar__S2aSh","cancelar":"Buttons_cancelar__oqxKI"};